import {CalendarParamsModel} from '@/types/channel/calendar/calendar.model';

export const CALENDAR_PREFIX = 'calendar';

/**
 * 캘린더 쿼리 키 생성 함수
 * @param params - 캘린더 파라미터
 * @returns 쿼리 키 배열
 */
const createCalendarQueryKey = (params: Partial<CalendarParamsModel>) => {
  const {userId, ...rest} = params;
  const baseKey = [CALENDAR_PREFIX, userId];

  const validParams: Record<string, any> = {};
  Object.entries(rest).forEach(([key, value]) => {
    if (value !== undefined) {
      validParams[key] = value;
    }
  });

  return Object.keys(validParams).length > 0
    ? [...baseKey, validParams]
    : baseKey;
};

export const STATION_CALENDAR_QUERY_KEY = {
  CALENDAR: (params: Partial<CalendarParamsModel>) =>
    createCalendarQueryKey(params),
} as const;
